import logo from "../../../img/logo-white.png";
import { createCapHeader, createMeta } from "../../../components/hocs/createCapHeader";

const title = "Talentpair";

export const Header = createCapHeader(
  <img src={logo} alt="Talentpair" width={100} style={{ marginBottom: "-5px" }} />,
);
export const Meta = createMeta(title);
